import { Middleware } from "../middleware"

export default {


    getUsersClients(filter) {
        return new Middleware()
            .append(`/users`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size
            })
            .method('GET')
            .build()

    },
    getUsersClientsNoFilter() {
        return new Middleware()
            .append(`/users/`)
            .method('GET')
            .build()

    },

    getUserCustomer(id) {
        return new Middleware()
            .method('GET')
            .append(`/users/${id}`)
            .build()
    },

    getProfileCustomer() {
        return new Middleware()
            .method('GET')
            .append(`/users/profiles`)
            .build()

    },

    saveUserClient(user) {
        return new Middleware()
            .method('POST')
            .append('/users/')
            .setData(user)
            .build()
    },

    updateUserCustomerUser(user, id) {
        return new Middleware()
            .method('PUT')
            .append(`/users/${id}`)
            .setData(user)
            .build()
    },


    deleteCustomerUser(id) {
        return new Middleware()
            .method('DELETE')
            .append(`/users/${id}`)
            .build()
    },

    resetPasswordCustomerUser(id) {
        return new Middleware()
            .method('PUT')
            .append(`/users/${id}/reset_password/`)
            .build()
    },
    getCustomers(filter) {
        return new Middleware()
            .method('GET')
            .append(`/companies`)
            .params({
                findBy: filter.search,
                page: filter.page,
                size: filter.size
            })
            .build()

    },
    getCustomersNoFilter() {
        return new Middleware()
            .method('GET')
            .append(`/companies/`)
            .build()
    },

    getCustomerById(id) {
        return new Middleware()
            .method('GET')
            .append(`/companies/${id}`)
            .build()

    },

    saveCustomer(customer) {
        return new Middleware()
            .method('POST')
            .append(`/companies/`)
            .setData(customer)
            .build()
    },

    updateCompanies(customer, id) {
        return new Middleware()
            .method('PUT')
            .append(`/companies/${id}`)
            .setData(customer)
            .build()

    },
    switchStatusCompanies(id) {
        return new Middleware()
            .method('PUT')
            .append(`/companies/${id}/switch_status`)
            .build()
    }

}